import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from 'providers/useAuth/AuthContext';
import { useServiceActivatedNotification } from 'components/Notification/Notification';
import { RootState } from 'providers/reducers';

export const SERVICE_ACTIVATED_EVENT = 'service-activated';

export const useServiceActivationWatcher = () => {
    const { accountInfo, isLoggedIn } = useAuth();
    const { synced: purchaseSynced } = useSelector((state: RootState) => state.purchaseSyncedStore);
    const showActivatedNotification = useServiceActivatedNotification();
    const prevServiceCodesRef = useRef<string[] | null>(null);

    useEffect(() => {
        if (!isLoggedIn) {
            prevServiceCodesRef.current = null;
        }
    }, [isLoggedIn]);

    useEffect(() => {
        const serviceCodes = accountInfo?.service_codes;

        if (!serviceCodes) {
            return;
        }

        const prevCodes = prevServiceCodesRef.current;

        if (prevCodes !== null && purchaseSynced) {
            const newCodes = serviceCodes.filter((code) => !prevCodes.includes(code));
            if (newCodes.length > 0) {
                const unhandled = window.dispatchEvent(new CustomEvent(SERVICE_ACTIVATED_EVENT, { cancelable: true }));

                if (unhandled) {
                    showActivatedNotification();
                }
            }
        }

        prevServiceCodesRef.current = serviceCodes;
    }, [accountInfo]);
};
